import { all, takeEvery, call, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions'
import axios from '../services';
import { sessionExpiredMsg } from "../constants/constants";

function* getSearchData(action) {
    try {
        let { newData } = action.payload;
        let url = `/users/search?searchType=${action.payload.type}&skip=${action.payload.length}&limit=10`;
        if (action.payload.keyword != '') {
            url += `&keyword=${action.payload.keyword}`;
        }
        let response = yield axios.post(url)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response.status == 200) {
            if (action.payload.type == 'contestant') {
                yield put(actions.getSearchContestantsDataSuccess({ data: response.data.data, newData }));
            } else if (action.payload.type == 'contest') {
                yield put(actions.getSearchContestDataSuccess({ data: response.data.data, newData }));
            } else if (action.payload.type == 'voters') {
                yield put(actions.getSearchVoterDataSuccess({ data: response.data.data, newData }));
            }
        }
        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else {
            yield put(actions.hideAppLoader());
            // yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA SEARCH", error.message);
    }
}

export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_SEARCH_DATA, getSearchData);
}